import { useEffect, useState, useCallback } from "react";
import axios from "axios";
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function UseQuestions() {
  const [questions, setQuestions] = useState([]);
  const load = useCallback(() => {
    async function loadData() {
      setQuestions([]);
      const response = await axios.get("data.json");
      const questions = [...response.data];
      shuffleArray(questions);
      setQuestions(questions.slice(0, 8));
    }
    loadData();
  }, []);

  useEffect(() => {
    load();
  }, [load]);
  return [questions, load];
}

export default UseQuestions;
